import {
  getNextOccurrence,
  inventoryPeriodConfigToCycle,
  toLocalDateStr,
} from '../components/cycleHelpers.mjs';

export { toLocalDateStr as localDateStr };

export function getTemplateKind(template) {
  if (template.order_calculations_enabled) return 'order';
  const preset = template.ordering_cycle_config?.preset;
  if (preset === 'eop_454' || preset === 'eop_544') return 'eop';
  return 'count';
}

// Whether a template should COUNT as an End of Period template for setup /
// readiness checks (e.g. "do you have an End of Period template yet?").
//
// IMPORTANT: this is broader than getTemplateKind(t) === 'eop'. getTemplateKind
// only treats the eop_454 / eop_544 accounting-cycle presets as EOP, but most
// real End of Period templates use an ordinary schedule (e.g. every_friday) and
// are marked End of Period by their count_purpose / inventory_mode. Detecting EOP
// by preset alone makes the setup checks claim a store has "no End of Period
// template" when it actually has several — so it must mirror how the templates
// page groups them into the "End of Period" section (getGroupSection in
// CountInterface.jsx) and how templates-convert's detectFormat reads the format.
//
// Rule: an order template is never EOP; otherwise EOP is decided by usage
// (count_purpose period_end/full_inventory, or inventory_mode Financial/Both),
// with the legacy eop_454/eop_544 presets still counting as EOP.
export function isEopTemplate(template) {
  if (!template || typeof template !== 'object') return false;
  if (template.order_calculations_enabled === true) return false;
  if (template.count_purpose === 'ordering') return false;
  const cp = template.count_purpose;
  const im = template.inventory_mode;
  if (cp === 'period_end' || cp === 'full_inventory') return true;
  if (im === 'Financial' || im === 'Both') return true;
  const preset = template.ordering_cycle_config?.preset;
  return preset === 'eop_454' || preset === 'eop_544';
}

export function getTemplateNextDate(template, storePeriodConfig) {
  let cycle = template.ordering_cycle_config;

  // Fall back to the store's period config only for EOP-kind templates.
  // Regular count and order templates without their own schedule are not
  // scheduled, so they should not produce a prep card.
  if (!cycle) {
    const kind = getTemplateKind(template);
    if (kind === 'eop' && storePeriodConfig) {
      cycle = inventoryPeriodConfigToCycle(storePeriodConfig);
    }
  }

  if (!cycle || cycle.preset === 'none') return null;

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return getNextOccurrence(cycle, toLocalDateStr(yesterday));
}

export function daysUntilDate(dateStr) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(dateStr + 'T00:00:00');
  return Math.floor((target - today) / 86400000);
}
